export default __webpack_public_path__ + "static/btn-94f5761a0261b4ad5a67a307c88e0cff.png";